import { render, staticRenderFns } from "./Scriptoria.vue?vue&type=template&id=e8f41330&scoped=true&"
import script from "./Scriptoria.vue?vue&type=script&lang=js&"
export * from "./Scriptoria.vue?vue&type=script&lang=js&"
import style0 from "./Scriptoria.vue?vue&type=style&index=0&id=e8f41330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f41330",
  null
  
)

export default component.exports